import React, { FC } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { TransactionListItemDto } from "../../../../common/types/transaction";
import {
    StandardModalBody,
    StandardModalHeader,
} from "../../../general/Modal/Modal";
import {
    GridTable,
    GridTableHeader,
} from "../../../general/Tables/GridTable/GridTable";
import styles from "./TransactionsModal.module.scss";
import { TransactionRow } from "./TransactionRow";

interface TransactionsModalProps {
    transactions: TransactionListItemDto[];
}

export const TransactionsModal: FC<TransactionsModalProps> = ({
    transactions,
}) => (
    <>
        <StandardModalHeader>All transactions</StandardModalHeader>

        <Scrollbars
            autoHeight
            autoHeightMin={400}
            style={{ maxHeight: "calc(100vh - 100px)" }}
        >
            <StandardModalBody className="p-0">
                <GridTable className={styles.table}>
                    <GridTableHeader className={styles.header}>
                        <div></div>
                        <div>Date</div>
                        <div>Description</div>
                        <div>Category</div>
                        <div>Account</div>
                        <div className={styles.amountColumn}>Amount</div>
                        <div />
                        {/* Empty cell for entity icon */}
                        <div />
                        {/* Empty cell for upload button */}
                        <div />
                        {/* Empty cell for dropdown */}
                    </GridTableHeader>

                    {transactions.map((transaction) => (
                        <TransactionRow
                            transaction={transaction}
                            key={transaction.id}
                        />
                    ))}
                </GridTable>
            </StandardModalBody>
        </Scrollbars>
    </>
);
